import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import applicant from './modules/applicant'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    applicant
  },
  getters
})

export default store
